import { render, staticRenderFns } from "./userActive.vue?vue&type=template&id=1be9dac2&scoped=true"
import script from "./userActive.vue?vue&type=script&lang=js"
export * from "./userActive.vue?vue&type=script&lang=js"
import style0 from "./userActive.vue?vue&type=style&index=0&id=1be9dac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9dac2",
  null
  
)

export default component.exports